export default {"src":"/_next/static/media/medical.caa53d6e.svg","height":194,"width":184};